module.exports = __webpack_public_path__ + "img/logo.fc50e604.png";